/**
 * Hook for tracking page views with React Router
 * Fires GA4 page_view on every route change — static and dynamic
 */
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../services/analyticsService';

// Static route titles
const PAGE_TITLES = {
  '/': 'Home - One Piece Trivia',
  '/quiz': 'Character Quiz - One Piece Trivia',
  '/image-quiz': 'Image Quiz - One Piece Trivia',
  '/devil-fruit-quiz': 'Devil Fruit Quiz - One Piece Trivia',
  '/leaderboard': 'Leaderboard - One Piece Trivia',
  '/profile': 'Profile - One Piece Trivia',
  '/login': 'Login - One Piece Trivia',
  '/privacy': 'Privacy Policy - One Piece Trivia',
  '/terms': 'Terms of Service - One Piece Trivia',
  '/about': 'About - One Piece Trivia',
  '/contact': 'Contact - One Piece Trivia',
  '/characters': 'Archive - One Piece Trivia',
  '/arcs': 'Story Arcs - One Piece Trivia',
  '/guides': 'Guides - One Piece Trivia',
  '/guides/straw-hat-crew': 'Straw Hat Crew Guide - One Piece Trivia',
  '/guides/devil-fruits': 'Devil Fruits Guide - One Piece Trivia',
  '/guides/characters': 'Allies Enemies Legends Guide - One Piece Trivia',
};

/**
 * Generate a clean title for dynamic routes
 * /characters/monkey-d-luffy -> "Monkey D Luffy - One Piece Trivia"
 * /arcs/marineford -> "Marineford Arc - One Piece Trivia"
 */
const getDynamicTitle = (path) => {
  if (path.startsWith('/characters/')) {
    const slug = path.replace('/characters/', '');
    const name = slug.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
    return `${name} - One Piece Trivia`;
  }
  if (path.startsWith('/arcs/')) {
    const slug = path.replace('/arcs/', '');
    const name = slug.split('-').map(w => w.charAt(0).toUpperCase() + w.slice(1)).join(' ');
    return `${name} Arc - One Piece Trivia`;
  }
  return `One Piece Trivia - ${path}`;
};

/**
 * Hook to automatically track page views on every route change
 * Works for all pages: static routes, character profiles, arc pages, guides
 */
const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    const title = PAGE_TITLES[path] || getDynamicTitle(path);

    // Send page view to GA4
    trackPageView(path, title);
  }, [location]);
};

export default usePageTracking;
